import { render } from "./BuyConfirm.vue?vue&type=template&id=a5893560&scoped=true"
import script from "./BuyConfirm.vue?vue&type=script&lang=js"
export * from "./BuyConfirm.vue?vue&type=script&lang=js"

import "./BuyConfirm.vue?vue&type=style&index=0&id=a5893560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5893560"]])

export default __exports__